import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { bindAll } from '@bibliocommons/utils-react';
import { TextButton } from '@bibliocommons/base-buttons';
import { Close as CrossIcon } from '@bibliocommons/base-icons';
import TextField from './TextField';

import './ClearableTextField.scss';

export class ClearableTextField extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
    this.input = React.createRef();
  }

  handleClear() {
    if (this.props.handleClear) {
      this.props.handleClear();
    }
    if (this.input.current) {
      this.input.current.focus();
    }
  }

  renderClearButtonScreenReaderText() {
    if (this.props.clearButtonSrText) {
      return <ScreenReaderMessage>{this.props.clearButtonSrText}</ScreenReaderMessage>;
    }

    return (
      <FormattedMessage id="ada_label_clear_search_text">
        {message => <ScreenReaderMessage>{message}</ScreenReaderMessage>}
      </FormattedMessage>
    );
  }

  renderClearButton() {
    if (!this.props.hideClearButton) {
      return (
        <TextButton className="clear-icon" handleClick={this.handleClear} type="button" dataKey="clear-button">
          <CrossIcon />
          {this.renderClearButtonScreenReaderText()}
        </TextButton>
      );
    }

    return null;
  }

  render() {
    return (
      <div className="cp-clearable-text-field">
        <TextField
          {...this.props}
          inputIcon={this.renderClearButton()}
          className={this.props.className}
          characterCountSrOnly={this.props.characterCountSrOnly}
          ref={this.input}
        />
      </div>
    );
  }
}
ClearableTextField.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  id: PropTypes.string.isRequired,
  info: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  maxLength: PropTypes.number,
  suggestedMaxLength: PropTypes.number,
  value: PropTypes.string,
  characterCountSrOnly: PropTypes.bool,
  inputIcon: PropTypes.element,
  optional: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]).isRequired,
  errorMessage: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]),
  size: PropTypes.oneOf(['small', 'large', 'extra-large']),
  dataKey: PropTypes.string,
  forwardedRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  hideClearButton: PropTypes.bool,
  handleClear: PropTypes.func,
  clearButtonSrText: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};

ClearableTextField.defaultProps = {
  hideClearButton: false
};

export default ClearableTextField;
